<template>
  <Icon
    :name="icon"
    :size="sizeInUnits"
    :class="{ 'me-2': start, 'ms-2': end }"
    class="icon"
    :style="{ color: resolvedColor }"
  />
</template>

<script setup lang="ts">
import { LABEL_COLORS } from '~/assets/constants';

const SIZES = {
  'x-small': '1em',
  'small': '1.25em',
  'default': '1.5em',
  'large': '1.75em',
  'x-large': '2em'
};

const {
  size,
  color
} = defineProps<{
  icon: string;
  size?: keyof typeof SIZES | number;
  color?: string;
  start?: boolean;
  end?: boolean;
}>();

const sizeInUnits = computed(() => {
  if (!size) return SIZES.default;
  return typeof size == 'number' ? size.toString() : SIZES[size];
});
const isLabelColor = color && LABEL_COLORS.includes(color);
const resolvedColor = isLabelColor ? `rgb(var(--v-theme-${color}))` : color;
</script>

<style scoped>
.icon {
  vertical-align: middle;
  flex-shrink: 0;
}
</style>